import { CssBaseline } from '@mui/material';
import {
  ThemeProvider as MuiThemeProvider,
  createTheme,
  responsiveFontSizes,
} from '@mui/material/styles';
import {
  ThemeProvider as StylesThemeProvider,
} from '@mui/styles';
import isMobile from 'is-mobile';
import React from 'react';
import { shape, spacing } from './consts';
import overrides from './overrides';
import palette from './palete';
import props from './props';
import shadows from './shadows';
import typography from './typography';

const baseConfig = {
  palette,
  typography,
  shadows,
  shape,
  spacing,
};

const baseTheme = createTheme(baseConfig);

const theme = responsiveFontSizes(
  createTheme({
    ...baseConfig,
    components: {
      ...overrides(baseTheme),
      ...Object.fromEntries(
        Object.entries(props(baseTheme)).map(([component, componentProps]) => [
          component,
          { ...(overrides(baseTheme)[component] || {}), defaultProps: componentProps },
        ]),
      ),
    },
  }),
);

type CustomTheme = typeof theme & {
  media: {
    mobile: string
  }
};

const themeNext = theme as CustomTheme;
themeNext.media = {
  mobile: baseTheme.breakpoints.down(isMobile() ? 'sm' : 'xs'),
};

const Theme: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <MuiThemeProvider theme={themeNext}>
    <StylesThemeProvider theme={themeNext}>
      <CssBaseline />
      {children}
    </StylesThemeProvider>
  </MuiThemeProvider>
);

export default Theme;
export { themeNext };
export type { CustomTheme as NextTheme };
